export const ID_PLACEHOLDER = "아이디를 입력해주세요";
export const PWD_PLACEHOLDER = "비밀번호를 입력해 주세요";
export const PHONE_PLACEHOLDER = "휴대폰번호를 입력해 주세요";
export const AUTH_TOKEN_PLACEHOLDER = "인증번호를 입력해 주세요";
export const INVALID_PASSWORD = "회원정보가 틀립니다. 다시 확인해주세요.";
export const LOCKED_USER =
  "로그인 시도가 5회 이상 실패하여, 1일 동안 접속이 제한되었습니다. 담당자에게 문의 바랍니다.";
export const DEACTIVATED_USER =
  "서비스 이용이 정지되었습니다. 관련 문의사항이 있을 경우, 고객센터에 문의 바랍니다.";
export const ID_NULL = "아이디를 입력해주세요";
export const PWD_NULL = "비밀번호를 입력해 주세요";
export const PHONE_NULL = "휴대폰번호 인증이 필요합니다.";
export const RESEND = "재전송하기";
export const NOT_PASS_REVIEW_ID = "NOT_PASS_REVIEW_ID";
